import { FancyButton } from '../../../components/primitives/FancyButton';
import { TpOrganizationInfo, TpPluginInfo } from '../../../api/models/admin';
import { promptOrganizationPluginsModal } from '../actions/m2mOrganizationPluginModal';
import { AdminApi } from '../../../api/models/m2mApi';
import { showErrorMessage } from '../../../components/message-boxes/ErrorMessage';

interface TpManagePluginsButtonProps {
  organization: TpOrganizationInfo;
  plugins: TpPluginInfo[];
  adminApi: AdminApi;
  toggleLoading: (enable: boolean, message?: string) => void;
  updateOrganizations: () => void;
}

const ManagePluginsButton = (props: TpManagePluginsButtonProps) => {
  const { organization, plugins, adminApi, toggleLoading, updateOrganizations } = props;

  const handlePluginAction = async () => {
    try {
      const pluginIds = await promptOrganizationPluginsModal(organization, plugins); // Wait for the modal to resolve
      const prevPlugins = organization.pluginIds;

      if (!pluginIds && !prevPlugins) {
        return;
      }
      toggleLoading(true, 'Updating organization plugins...');

      const pluginsToRemove = prevPlugins?.filter((pluginId) => !pluginIds?.includes(pluginId)) || [];
      const pluginsToAdd = pluginIds?.filter((pluginId) => !prevPlugins?.includes(pluginId)) || [];

      // to avoid race conditions, we process the promises in series
      for (const pluginId of pluginsToRemove) {
        await adminApi.removeOrganizationPlugin(organization.identifier!, pluginId);
      }

      for (const pluginId of pluginsToAdd) {
        await adminApi.addOrganizationPlugin(organization.identifier!, pluginId);
      }

      toggleLoading(false);
      updateOrganizations();
    } catch (err) {
      console.error('Error updating organization plugins:', err);
      toggleLoading(false);
      showErrorMessage('An error occurred while updating organization plugins');
    }
  };

  return (
    <FancyButton iconName="fas:puzzle" onClick={handlePluginAction}>
      Manage Plugins
    </FancyButton>
  );
};

export default ManagePluginsButton;
